import { render } from "./setting-lesson.vue?vue&type=template&id=12af8423"
import script from "./setting-lesson.vue?vue&type=script&lang=js"
export * from "./setting-lesson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__